import { CompanyDetailReviewCategory } from "@/api/types";

export const REVIEW_CATEGORY_MAP = {
  [CompanyDetailReviewCategory.INTERN]: {
    rating1: "業界・事業の魅力",
    rating2: "社風・人の魅力",
    rating3: "自己成長度",
    rating4: "参加学生のレベル",
    rating5: "選考の難易度",
    rating6: "本選考への影響度"
  },
  [CompanyDetailReviewCategory.RECRUITMENT]: {
    rating1: "業界・事業の魅力",
    rating2: "社風・人の魅力",
    rating3: "仕事内容・キャリアの魅力",
    rating4: "働く環境の魅力",
    rating5: "待遇の魅力",
    rating6: "本選考の難易度"
  },
  [CompanyDetailReviewCategory.SEMINAR]: {
    rating1: "社風・人の魅力",
    rating2: "業界・事業の理解度",
    rating3: "参加学生のレベル",
    rating4: "採用・選考情報の理解度",
    rating5: "仕事内容・キャリアの魅力",
    rating6: "働く環境の魅力"
  }
} as const;
